export default class TixStripeError extends Error {
    originalStripeError;
    stripeError = true;
    // originalStripeError is used in CheckoutRoute.
    constructor(originalStripeError) {
        super();
        this.originalStripeError = originalStripeError;
    }
}
